import { gql } from "@apollo/client";

export const GET_NOTES = gql`
  query GetAllNotes($id: String!) {
    allNotesByObjectId(id: $id) {
      note
      id
      createdAt
      modifiedAt
    }
  }
`; 

export const CREATE_NOTE = gql`
  mutation createNote($objectId: String!, $note: String!) {
    createNote(mdmObjectId: $objectId, note: $note) {
      modifiedAt
      createdAt
      id
      note
    }
  }
`; 

export const DELETE_NOTE = gql`
  mutation deleteNote($id: BigInteger!) {
    deleteNote(id: $id)
  }
`;